import React, { CSSProperties, useState, useEffect, useCallback } from "react";
// import "rc-drawer/assets/index.css";
import { DrawerGlobalCss, drawerPrefix } from "./Drawer.styled";
import RcDrawer, { DrawerProps as RcDrawerProps } from "rc-drawer";
import motionProps from "./motion";
import { Container } from "../../Components/Grid";
import FlexBox from "../../Components/FlexBox/FlexBox";
import Icon from "../../Foundation/Icon/Icon";
import { useTheme } from "../../Themes/defaultTheme";
import ios from "../../Utils/ios";
import SpanButton from "../../General/Reset/SpanButton/SpanButton";

export interface IDrawerProps extends Omit<RcDrawerProps, "prefixCls"> {
  closable?: boolean;
  // Only on closable equal true
  containerStyle?: CSSProperties;
  width?: number | string;
  childrenWrapper?: CSSProperties;
  disableAnimation?: boolean;
}

const Drawer = (props: IDrawerProps) => {
  const {
    closable,
    children,
    open: defaultOpen,
    onClose,
    containerStyle,
    childrenWrapper = {},
    forceRender = true,
    destroyOnClose = false,
    disableAnimation,
    ...rest
  } = props;
  const [open, setOpen] = useState<boolean>(defaultOpen || false);
  const { color } = useTheme();
  const verticalSpacing = 30;

  useEffect(() => {
    if (defaultOpen !== undefined && defaultOpen !== open) {
      setOpen(defaultOpen);
    }
  }, [defaultOpen]);

  const handleClose: RcDrawerProps["onClose"] = useCallback(
    (
      e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>
    ) => {
      onClose && onClose(e);
      if (closable) setOpen(false);
    },
    []
  );

  return (
    <>
      <DrawerGlobalCss />
      <RcDrawer
        prefixCls={drawerPrefix}
        destroyOnClose={destroyOnClose}
        open={open}
        onClose={handleClose}
        {...rest}
        {...(!ios() && !disableAnimation && motionProps)}
        forceRender={forceRender ?? motionProps.forceRender}
      >
        {closable ? (
          <>
            <Container
              style={{
                paddingTop: verticalSpacing,
                position: "sticky",
                top: 0,
                zIndex: 1053,
                ...containerStyle,
              }}
            >
              <FlexBox
                justify="flex-end"
                style={{
                  width: "100%",
                }}
              >
                <SpanButton
                  onClick={handleClose}
                  style={{ display: "inline-flex", cursor: "pointer" }}
                >
                  <Icon icon="cross_close" color={color.black} />
                </SpanButton>
              </FlexBox>
            </Container>
            <div
              style={{
                ...childrenWrapper,
                // paddingBottom: verticalSpacing,
              }}
            >
              {children}
            </div>
          </>
        ) : (
          children
        )}
      </RcDrawer>
    </>
  );
};

export default Drawer;
